import React, { useContext } from 'react';

import { Box, BorderBox, LabelGroup, Avatar, Label } from '@primer/components'
import ReactDiffViewer from 'react-diff-viewer';
import { Link } from "react-router-dom";


import { ImpactLabel, CategoryLabel } from '../Advice'
import { CorpusContext } from '../../hooks/useCorpus'
import { useProduct } from '../../hooks/useProduct'


export default function(props) {
  if (!props.exampleTitle) {
    return null
  }
  const { corpus, routes } = useContext(CorpusContext)

  const { Summary } = corpus[props.code]
  const adviceUrl = routes[props.code]
  const productDetails = useProduct()

  const botName = productDetails.id === 'djangodoctor' ? 'django-doctor' : 'code-review-doctor'

  return (
    <Box className="django-doctor-before-after"  style={{borderBottomLeftRadius: "6px", borderBottomRightRadius: "6px", maxWidth: 500}}>
      <BorderBox className="bg-gray p-2 f5 text-mono" style={{borderBottomLeftRadius: 0, borderBottomRightRadius: 0, borderBottom: 0}}>
        {props.exampleTitle.replace("/tmp/patient/", "")}
        { 
          props.showLabels && (
            <LabelGroup style={{float: 'right'}}>
              <CategoryLabel messageId={props.code} />
              <ImpactLabel style={{verticalAlign: "middle"}} messageId={props.code} />
            </LabelGroup>
          )
        }
      </BorderBox>
      <BorderBox className="bg-white" style={{borderRadius: 0}}>
        <ReactDiffViewer
          oldValue={props.exampleBefore}
          newValue={props.exampleAfter}
          splitView={false}
          hideLineNumbers={true}
          showDiffOnly={false}
          disableWordDiff={true}
        />
      </BorderBox>
      {!props.hideDetails && (
        <Box bg="white" className="p-2" style={{borderBottomLeftRadius: 6, borderBottomRightRadius: 6, borderRight: '1px solid #dedede', borderLeft: '1px solid #dedede', borderBottom: '1px solid #dedede'}}>
          <nav>
            <Avatar src="/favicon.png" size={32} />
            <strong className="pl-2 pr-2">{botName}</strong>
            <Label variant="small" sx={{border: "1px solid grey", color: "grey", backgroundColor: "white"}}>bot</Label>
            <span  className="pl-2">just now</span>
          </nav>
          <Box className={`${props.textClassName} p-2 clearfix ml-md-5`}>
            <Summary className="d-inline" />
            <span> <Link to={adviceUrl} target="_blank" className={`${props.textClassName} text-underline`}>Read more</Link> </span>
          </Box>
        </Box>
      )}
    </Box>
  )
}